var divider_viewer_rtlignore_default = {
  "divider-container": "QAPlK",
  "divider-container--double": "_17eHG",
  "divider": "o99V-",
  "divider--single": "Tm1T-",
  "divider--double": "iEBm2",
  "divider--dashed": "_2Ws7E",
  "divider--dotted": "d3LLF",
  "divider--small": "u5a-E",
  "divider--medium": "xEH-H",
  "divider--large": "xLT1y",
  "divider--left": "wLLns",
  "divider--center": "R3r3G",
  "divider--right": "psPQU",
  "svgFixerContainer": "t0Giv",
  "emptyChar": "xI642"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
